import React, { useState } from "react";
import "./navbar_landingpage.css";
import warpoLogo from "./warpo.png";
import buetLogo from "./cse_buet.png";
import { Avatar, Menu, MenuItem, IconButton} from "@mui/material";
import { FaHome } from "react-icons/fa";
import { FaSignOutAlt } from "react-icons/fa";
import { IoPersonCircle } from "react-icons/io5";


const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onHomeClick = () => {
    window.location.href = "/home"; // Redirect to home page
    console.log("Home clicked");
  }
  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    // Go to profile page logic here
    window.location.href = "/profile"; // Redirect to profile page
    console.log("Profile clicked");
    handleMenuClose();
  };


  const handleLogoutClick = () => {
    handleMenuClose();
    // Perform logout logic here
    console.log("Logout clicked");
    localStorage.removeItem("token"); // Remove token from local storage
    localStorage.removeItem("role"); // Remove role from local storage
    window.location.href = "/"; // Redirect to login page
  };

  const onMapClick = () => {
    window.location.href = "/map"; // Redirect to map page
    console.log("Map clicked");
  };

  return (
    <div className="navbar">
      <div className="navbar-left" >
        <img src={warpoLogo} alt="Warpo Logo" className="navbar-logo" />
        <img src={buetLogo} alt="CSE BUET Logo" className="navbar-logo navbar-logo--secondary" />
      </div>

    
      <div className="navbar-right">
      <button className="nav-button" onClick={onMapClick}>
          Go to Map
        </button>
      <button className="nav-button" onClick={onHomeClick}>
        <FaHome  /> Home
      </button>
       

        <IconButton
          onClick={handleAvatarClick}
          className="navbar-avatar-btn"
          aria-label="Account menu"
          sx={{ p: 0.25 }}
        >
          <Avatar
            alt="Account"
            src="/path-to-image.jpg"
            sx={{
              width: 40,
              height: 40,
              bgcolor: "rgba(255,255,255,0.92)",
              color: "#1e5278",
              fontWeight: 700,
              fontSize: "1rem",
              border: "2px solid rgba(30, 82, 120, 0.2)",
            }}
          />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            elevation: 3,
            sx: {
              mt: 1.5,
              borderRadius: "12px",
              minWidth: 180,
              boxShadow: "0 8px 28px rgba(21, 52, 72, 0.14)",
              border: "1px solid rgba(21, 52, 72, 0.08)",
              "& .MuiMenuItem-root": {
                gap: 1,
                py: 1.25,
                px: 1.5,
                fontSize: "0.9375rem",
                color: "#1c2d38",
              },
            },
          }}
        >
          <MenuItem onClick={handleProfileClick}>
            <IoPersonCircle style={{ fontSize: "1.15rem", opacity: 0.85 }} />
            Profile
          </MenuItem>
          <MenuItem onClick={handleLogoutClick}>
            <FaSignOutAlt style={{ fontSize: "1rem", opacity: 0.85 }} />
            Logout
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Navbar;
